// export const mockClientItems = (itemsNumber = 100) => {
//   const mockItems = [];

//   for (let i = 1; i < itemsNumber + 1; i += 1) {
//     mockItems.push({
//       key: `${i}`,
//       DeviceName: `PPJ_STL_001_FP02`,
//       Status: Math.random() < 0.5 ? "Green" : "Red",
//     });
//   }
//   return mockItems;
// };

export const mockServerItems = async (serverOptions, items) => {
  const { page, rowsPerPage, sortBy, sortType } = serverOptions;

  console.log(page, rowsPerPage, sortBy, sortType);
  const serverItemsLength = items.length;
  const serverTotalItems = items;
  if (sortBy && sortType) {
    serverTotalItems.sort((a, b) => {
      if (a[sortBy] < b[sortBy]) return sortType === "desc" ? 1 : -1;
      if (a[sortBy] > b[sortBy]) return sortType === "desc" ? -1 : 1;
      return 0;
    });
  }
  await new Promise((s) => setTimeout(s, 2000));
  return {
    serverCurrentPageItems: serverTotalItems.slice(
      (page - 1) * rowsPerPage,
      page * rowsPerPage
    ),
    serverTotalItemsLength: serverItemsLength,
  };
};
